import {
  Briefcase,
  Building2,
  Factory,
  Scan,
  Stethoscope,
  type LucideIcon,
} from "lucide-react";
import type { PartnerType, PartnerStatus } from "@bookdental/schemas";

export const PARTNER_TYPE_META: Record<
  PartnerType,
  { label: string; plural: string; icon: LucideIcon; color: string; hint: string }
> = {
  DENTIST: {
    label: "Dentista",
    plural: "Dentistas",
    icon: Stethoscope,
    color: "#2457ff",
    hint: "Clínicos e cirurgiões-dentistas parceiros",
  },
  LAB: {
    label: "Laboratório",
    plural: "Laboratórios",
    icon: Factory,
    color: "#0ea5e9",
    hint: "Laboratórios de prótese e CAD/CAM",
  },
  RADIOLOGY: {
    label: "Radiologia",
    plural: "Radiologias",
    icon: Scan,
    color: "#06b6d4",
    hint: "Centros de radiologia e imagem",
  },
  CLINIC_NETWORK: {
    label: "Rede de clínicas",
    plural: "Rede de clínicas",
    icon: Building2,
    color: "#10b981",
    hint: "Clínicas parceiras em rede",
  },
  SUPPLIER: {
    label: "Fornecedor",
    plural: "Fornecedores",
    icon: Briefcase,
    color: "#f59e0b",
    hint: "Fornecedores de materiais, equipamentos e serviços",
  },
};

export const PARTNER_STATUS_META: Record<
  PartnerStatus,
  { label: string; color: string; bg: string }
> = {
  ACTIVE: { label: "Ativo", color: "#059669", bg: "#10b98114" },
  INACTIVE: { label: "Inativo", color: "#71717a", bg: "#71717a14" },
};

export function formatDoc(doc: string | null | undefined): string {
  if (!doc) return "";
  const d = doc.replace(/\D/g, "");
  if (d.length === 11) {
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  }
  if (d.length === 14) {
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(
      8,
      12,
    )}-${d.slice(12)}`;
  }
  return doc;
}

export function formatPhone(v: string | null | undefined): string {
  if (!v) return "";
  const d = v.replace(/\D/g, "");
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return v;
}
